import { createContext } from 'react'

export const defaultDebug = false // DEBUG ATIVO ===> Usar este local para controlar em toda a aplicação
                                  
const DebugContext = createContext({debug:defaultDebug, setDebug: () => {}}) 

export default DebugContext